import React from "react";
import emptyIcon from "../../../assets/icons/emptyIcon.svg"; // replace with your icon
import "./no-records-component.scss"; // Ensure you have the styles for this component
import { NoRecordsComponentProps } from "./no-records-component.props";

/** Displays an empty-state message with optional title and message. */
const NoRecordsComponent: React.FC<NoRecordsComponentProps> = ({
  title,
  message,
}) => {
  return (
    <div className="empty-state">
      <img src={emptyIcon} alt="No Data" className="empty-icon" />
      <h3>{title || "No data available to display"}</h3>
      <p>{message || <>Please reload the page, or add new data.</>}</p>
    </div>
  );
};

export default NoRecordsComponent;
